/** Naptári segédek a tanácsadó motorokhoz. Minden dátum ISO `YYYY-MM-DD`. */

export function todayIso(now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function isoToUtcMs(iso: string): number | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return null;
  return Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}

/** `to - from` napokban. Pozitív, ha `to` későbbi. */
export function daysBetween(from: string, to: string): number | null {
  const a = isoToUtcMs(from);
  const b = isoToUtcMs(to);
  if (a === null || b === null) return null;
  return Math.round((b - a) / 86_400_000);
}

export function addDays(iso: string, days: number): string {
  const ms = isoToUtcMs(iso);
  if (ms === null) return iso;
  const d = new Date(ms + days * 86_400_000);
  return d.toISOString().slice(0, 10);
}

/** Timestamp (`created_at`, `updated_at`) → naptári nap. */
export function timestampToIsoDate(ts: string | null | undefined): string | null {
  if (!ts) return null;
  const m = /^(\d{4}-\d{2}-\d{2})/.exec(ts);
  return m?.[1] ?? null;
}

export function formatHuDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  return `${m[1]}. ${m[2]}. ${m[3]}.`;
}
